import CommentTabsComponent from '@root/core/components/CommentTabs';
import {
  CommentGroup,
  CommentList,
  CommentType,
  CreateComment,
  Comment,
  CommentSide,
  CommentStatus
} from '@root/core/components/CommentTabs/interface';
import Popup from '@root/core/components/Popup';
import Approve from '@root/core/components/WarehouseAdmin/button/approve';
import CommentSeller from '@root/modules/Sellers/Inquiry/components/CommentSeller';
import InquiryServices from '@root/modules/Sellers/Inquiry/services/inquiry';
import commentService from '@root/core/components/CommentTabs/commentService';
import { ProductContext } from '@root/modules/Sellers/provider/ProductProvider';
import inquiryService from '@root/modules/Warehouse/Inquiry/service/inquiry';
import { message, Modal } from 'antd';
import cloneDeep from 'lodash.clonedeep';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IComment } from '../../interface';
import CommentWarehouse from './CommentWarehouse';
import DetailsPro from './details-pro';
import CheckPoint from './shipping/CheckPoint';
import ShipmentMethod from './shipping/ShipmentMethod';
import ShipmentMethodCanEdit from './shipping/ShipmentMethodCanEdit';
import ShippingPlant from './shipping/ShippingPlant';

const { confirm } = Modal;

interface Props {
  comment?: any;
  proWareItem?: any;
  proDeWare?: any;
  productItem?: any;
  status?: any;
  flag?: boolean;
  onHandle?: () => void;
  onHandleReject?: () => void;
  setLoadingCmt?: boolean;
  product?: Array<string>;
  getListQuotationDetail?: any;
  statusQuotation?: any;
  getDetail?: any;
  isUpdate?: Boolean;
  onChange?: any;
  side?: 'WAREHOUSE' | 'SELLER';
  screenName?: 'SELLER_INQUIRY_DETAIL' | 'WAREHOUSE_INQUIRY_DETAIL';
  disabledComment?: boolean;
}

const DetailDescript = ({
  comment,
  proWareItem,
  proDeWare,
  getDetail,
  getListQuotationDetail,
  productItem,
  setLoadingCmt,
  isUpdate,
  onChange,
  side,
  screenName,
  disabledComment
}: Props) => {
  const { id }: any = useParams();
  const { productId }: any = useParams();
  const [product] = useContext<any>(ProductContext);
  const [openApprove, setOpenApprove] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [disableCommentTab, setDisableCommentTab] = useState(false);
  const [commentList, setCommentList] = useState<CommentList>();
  /*---------open popup reject---------------------*/

  const handleOpenReject = () => {
    setOpenReject(!openReject);
  };

  const handleCloseReject = () => {
    setOpenReject(false);
  };
  /*---------open popup approve---------------------*/

  const handleOpenApprove = () => {
    setOpenApprove(!openApprove);
  };

  /*---------------OK reject-------------------*/
  const handleOKRejectWare = async () => {
    try {
      setOpenReject(false);
      setLoading(true);
      const rejectDeWare = await inquiryService.postReject(id);
      getDetail();
      message.success('Reject success!');
      const { data } = rejectDeWare;
    } catch (error: any) {
      setOpenReject(false);
      const { response } = error;
      message.error("Can't reject");
    }
  };

  /*---------------OK approve-------------------*/
  const handleOKApproveWare = async () => {
    try {
      setOpenApprove(false);
      setLoading(true);
      const rejectDeWare = await inquiryService.postApprove(id);
      getDetail();
      message.success('Approve success!');
      const { data } = rejectDeWare;
    } catch (error: any) {
      setOpenReject(false);
      const { response } = error;
      message.error("Can't approve");
    }
  };

  /*---------------OK reject seller-------------------*/
  const handleOKRejectSeller = async () => {
    try {
      const rejectDeSell = await InquiryServices.postRejectSell(productId);
      getListQuotationDetail();
      setOpenReject(false);
      message.success('Reject success!');
      const { data } = rejectDeSell;
    } catch (error: any) {
      setOpenReject(false);
      const { response } = error;
      message.error("Can't reject");
    }
  };

  /*---------------OK approve seller-------------------*/
  const handleOKApproveSeller = async () => {
    try {
      const approveDeSell = await InquiryServices.postApproveSell(productId);
      getListQuotationDetail();
      setOpenApprove(false);
      message.success('Approve success!');
      const { data } = approveDeSell;
    } catch (error: any) {
      setOpenApprove(false);
      const { response } = error;
      message.error("Can't approve");
    }
  };

  /*-----------------------find last comment---------------*/
  const [myLastComment, setLMyLastComment] = useState<IComment>();
  const [listCmt, setListCmt] = useState([] as any);

  const getCommentList = async (showLoading?: Boolean) => {
    if (showLoading) {
      setLoading(true);
    }
    const comments = await commentService.getComments({
      group: CommentGroup.INQUIRY_DETAIL,
      itemId: productId ?? id
    });

    switch (screenName) {
      case 'SELLER_INQUIRY_DETAIL':
        const oldOcomments: any[] = (
          await InquiryServices.getQuoteComment(productId)
        )?.data;

        setCommentList({
          data: [
            ...oldOcomments.map((o) => {
              return {
                id: `old_${o.id}`,
                type: CommentType.COMMON,
                group: CommentGroup.INQUIRY_DETAIL,
                comment: o.comment,
                createdAt: o.created_at,
                side:
                  o.owner === 'Seller'
                    ? CommentSide.SELLER
                    : CommentSide.WAREHOUSE,
                status: CommentStatus.REQUEST,
                attachments: o.documents
              };
            }),
            ...comments.data
          ]
        });
        setDisableCommentTab(
          comments.data.filter((c: Comment) => c.side === CommentSide.WAREHOUSE)
            .length === 0
        );
        break;
      case 'WAREHOUSE_INQUIRY_DETAIL':
        if (proDeWare?.comments) {
          setCommentList({
            data: [
              ...proDeWare?.comments?.map((o: any) => {
                return {
                  id: `old_${o.id}`,
                  type: CommentType.COMMON,
                  group: CommentGroup.INQUIRY_DETAIL,
                  comment: o.comment,
                  createdAt: o.created_at,
                  side:
                    o.owner === 'Seller'
                      ? CommentSide.SELLER
                      : CommentSide.WAREHOUSE,
                  status: CommentStatus.REQUEST,
                  attachments: o.documents
                };
              }),
              ...comments.data
            ]
          });
        } else {
          setCommentList(comments);
        }
        setDisableCommentTab(disabledComment!);
        break;
      default:
        setCommentList(comments);
        break;
    }

    if (showLoading) {
      setLoading(false);
    }
  };

  const onSendComment = async (body: CreateComment, id?: number) => {
    setLoading(true);
    // send comment
    if (body.files && body.files.length) {
      const files = body.files;
      const fileResult = await commentService.commentUpload({
        attachments: files
      });
      body.attachmentIds = (fileResult?.data?.attachments ?? [])
        .map((f: any) => f.id)
        .join(',');
    }

    if (id) {
      await commentService.updateComment(id, body);
    } else {
      await commentService.sendComment(body);
    }
    await getCommentList();
    setLoading(false);
  };

  const _getData = useCallback(async () => {
    if (id) {
      const responseData = await inquiryService.getListComment(id);
      setListCmt(responseData.data);
      const commentList = responseData.data;

      const lastComment: IComment = commentList.at(-1);
      if (lastComment?.owner === 'Seller') {
        setLMyLastComment(lastComment);
      }
    }
  }, [id]);

  const [updateData, setUpdate] = useState<any>();

  useEffect(() => {
    setUpdate({
      products: (productItem ?? []).map((item: any, index: number) => {
        return {
          id: item.id,
          productName: item.productName,
          width: item.width,
          height: item.height,
          length: item.length,
          demensionUnit: item.demensionUnit,
          weight: item.weight,
          weightUnit: item.weightUnit,
          estimateQuantity: item.estimateQuantity,
          averageMonthSale: item.averageMonthSale,
          sku: item.sku,
          eanUpc: item.eanUpc,
          asin: item.asin,
          packedMethod: item.packedMethod,
          storageMethod: item.storageMethod,
          dangerousGoods: item.dangerousGoods,
          lotProduct: item.lotProduct
        };
      }),
      shipmentMethod: product.shipmentMethod,
      shipmenDetail: product.shipmentDetail,
      shippingPlanEtd: product.shippingPlanEtd,
      shippingPlanEta: product.shippingPlanEta,
      checkPoint: product.checkPoint
    });

    getCommentList();
  }, [productItem]);

  useEffect(() => {
    onChange?.(updateData);
  }, [updateData]);

  useEffect(() => {
    getCommentList();
  }, [proDeWare]);

  useEffect(() => {
    _getData();
  }, [_getData]);

  return (
    <>
      {productId ? (
        <>
          {(productItem || []).map((item: any, index: number) => {
            return (
              <DetailsPro
                key={index}
                productName={item.productName}
                width={item.width}
                height={item.height}
                length={item.length}
                demensionUnit={item.demensionUnit}
                weight={item.weight}
                weightUnit={item.weightUnit}
                estimateQuantity={item.estimateQuantity}
                averageMonthSale={item.averageMonthSale}
                sku={item.sku}
                eanUpc={item.eanUpc}
                asin={item.asin}
                packedMethod={item.packedMethod}
                storageMethod={item.storageMethod}
                dangerousGoods={item.dangerousGoods}
                lotProduct={item.lotProduct}
                img={item.image}
                isUpdate={isUpdate}
                onChange={(e: any) => {
                  const product = updateData?.products?.[index];
                  if (product) {
                    const products = cloneDeep(updateData.products);
                    const packedMethod = (e?.packedMethod ?? []).join(', ');
                    const storageMethod = (e?.storageMethod ?? []).join(', ');

                    products[index] = {
                      ...e,
                      id: item.id,
                      dangerousGoods: e?.dangerousGoods === 1,
                      packedMethod:
                        packedMethod === 'Direct input'
                          ? e?.packedInput
                          : packedMethod,
                      storageMethod:
                        storageMethod === 'Direct input'
                          ? e?.storageMethodInput
                          : storageMethod,
                      lotProduct:
                        e?.lotProduct === 'Direct input'
                          ? e?.lotProductInput
                          : e?.lotProduct
                    };
                    setUpdate({
                      ...updateData,
                      products
                    });
                  }
                }}
              />
            );
          })}
          <div style={{ display: 'flex', marginTop: '15px', gap: '10px' }}>
            <ShipmentMethodCanEdit
              shipmentMethod={product.shipmentMethod}
              shipmenDetail={product.shipmentDetail}
              onchange={(e: any) =>
                setUpdate({
                  ...updateData,
                  ...e
                })
              }
              isUpdate={isUpdate}
            />
            <ShippingPlant
              shippingPlanEtd={product.shippingPlanEtd}
              shippingPlanEta={product.shippingPlanEta}
              onChange2={(e: any) => {
                setUpdate({ ...updateData, ...e });
              }}
              isDisabled={!isUpdate}
            />
            <CheckPoint
              checkPoint={product.checkPoint}
              statusBox={isUpdate}
              handleChange={(v: any) =>
                setUpdate({ ...updateData, checkPoint: v.target.value })
              }
            />
          </div>
          {comment ? (
            <>
              {screenName !== 'SELLER_INQUIRY_DETAIL' ? (
                <CommentSeller
                  setLoadingCmt={setLoadingCmt}
                  statusSeller={product.progressStatus}
                  isParentUpdate={isUpdate}
                />
              ) : null}
            </>
          ) : (
            <CommentWarehouse />
          )}
          {isUpdate ? null : (
            <>
              <CommentTabsComponent
                tabs={[
                  {
                    title: 'Comment',
                    type: CommentType.COMMON,
                    commentDescription: 'Comment from Customer :',
                    imageUpload: true,
                    imageDescription: 'Customer’s attachments'
                  }
                ]}
                itemId={productId}
                commentGroup={CommentGroup.INQUIRY_DETAIL}
                onSend={onSendComment}
                refectComments={getCommentList}
                commentList={commentList!}
                disabled={disableCommentTab}
                showAttachmentsDownload={screenName === 'SELLER_INQUIRY_DETAIL'}
              />
              <div
                style={{
                  display: 'flex',
                  marginTop: '15px',
                  gap: '10px',
                  justifyContent: 'flex-end'
                }}
              >
                <span onClick={handleOpenReject}>
                  <Approve
                    productId={productId}
                    statusToDisable={product.progressStatus}
                    title="거절"
                    primary="red"
                  />
                </span>
                <span onClick={handleOpenApprove}>
                  <Approve
                    productId={productId}
                    statusToDisable={product.progressStatus}
                    title="승인"
                    primary="green"
                  />
                </span>
              </div>
            </>
          )}

          <Popup
            styleBackground="white"
            styleColor="#2A2D51"
            visible={openReject}
            title="거절 하시겠습니까?"
            // text="Do you want to reject this inquiry?"
            action_oke={handleOKRejectSeller}
            action_cancel={() => setOpenReject(false)}
            url={'/admin/seller/quote'}
            textCancel="취소"
            textOk="확인"
          />
          <Popup
            styleBackground="white"
            styleColor="#2A2D51"
            visible={openApprove}
            title="승인 하시겠습니까?"
            // text="Do you want to approve this inquiry?"
            action_oke={handleOKApproveSeller}
            action_cancel={() => setOpenApprove(false)}
            url={'/admin/seller/quote'}
            textCancel="취소"
            textOk="확인"
          />
        </>
      ) : (
        <>
          {proWareItem.map((item: any, index: number) => {
            return (
              <DetailsPro
                key={index}
                productName={item.productName}
                width={item.width}
                height={item.height}
                length={item.length}
                demensionUnit={item.demensionUnit}
                weight={item.weight}
                weightUnit={item.weightUnit}
                estimateQuantity={item.estimateQuantity}
                averageMonthSale={item.averageMonthSale}
                sku={item.sku}
                eanUpc={item.eanUpc}
                asin={item.asin}
                packedMethod={item.packedMethod}
                storageMethod={item.storageMethod}
                dangerousGoods={item.dangerousGoods}
                lotProduct={item.lotProduct}
                img={item.image}
              />
            );
          })}
          <div style={{ display: 'flex', marginTop: '15px', gap: '10px' }}>
            <div style={{ width: '33%' }}>
              <ShipmentMethod
                shipmentMethod={proDeWare?.shipmentMethod}
                shipmenDetail={proDeWare?.shipmentDetail}
              />
            </div>
            <div style={{ width: '66%', display: 'flex', gap: '10px' }}>
              <div style={{ width: '50%' }}>
                <ShippingPlant
                  shippingPlanEtd={proDeWare?.shippingPlanEtd}
                  shippingPlanEta={proDeWare?.shippingPlanEta}
                  onChange={() => {}}
                />
              </div>
              <div style={{ width: '50%' }}>
                <CheckPoint checkPoint={proDeWare?.checkPoint} />
              </div>
            </div>
          </div>
          <br />
          {/*{comment ? (*/}
          {/*  <CommentSeller />*/}
          {/*) : (*/}
          {/*  <CommentWarehouse*/}
          {/*    setLoadingCmt={setLoadingCmt}*/}
          {/*    statusWarehouse={proDeWare?.status}*/}
          {/*  />*/}
          {/*)}*/}
          <CommentTabsComponent
            tabs={
              disableCommentTab
                ? []
                : [
                    {
                      title: 'Comment',
                      type: CommentType.COMMON,
                      commentDescription: 'Comment from Warehouse :',
                      imageUpload: true,
                      imageDescription: 'Warehouse’s attachments'
                    },
                    {
                      title: 'Request modify',
                      type: CommentType.REQUEST_MODIFY,
                      commentDescription: 'Reason for modification :',
                      imageUpload: true,
                      imageDescription: 'Warehouse’s attachments'
                    }
                  ]
            }
            itemId={id}
            commentGroup={CommentGroup.INQUIRY_DETAIL}
            onSend={onSendComment}
            refectComments={getCommentList}
            commentList={commentList!}
            disabled={disableCommentTab}
          />
          <div
            style={{
              display: 'flex',
              marginTop: '15px',
              gap: '10px',
              justifyContent: 'flex-end'
            }}
          >
            <span onClick={handleOpenReject}>
              <Approve
                statusToDisable={proDeWare?.status}
                title="Reject"
                primary="red"
              />
            </span>
            <span onClick={handleOpenApprove}>
              <Approve
                statusToDisable={proDeWare?.status}
                title="Approve"
                primary="green"
                listCmt={listCmt?.length}
                mylastComment={myLastComment?.owner}
              />
            </span>
          </div>
          <Popup
            styleBackground="white"
            styleColor="#2A2D51"
            visible={openReject}
            title="Reject"
            text="Do you want to reject this inquiry?"
            action_oke={handleOKRejectWare}
            action_cancel={() => setOpenReject(false)}
          />
          <Popup
            styleBackground="white"
            styleColor="#2A2D51"
            visible={openApprove}
            title="Approve"
            text="Do you want to approve this inquiry?"
            action_oke={handleOKApproveWare}
            action_cancel={() => setOpenApprove(false)}
          />
        </>
      )}
    </>
  );
};

export default DetailDescript;
